import Dropdown from 'react-bootstrap/Dropdown';
import DownArrow from '@/assets/img/down-arrow.svg';
import { ReactElement, useEffect, useState } from 'react';
import ListCheck from '@/assets/img/list-check-icon.svg';
export type DropDownProps = {
  data: {
    label: string;
    value: any;
    additionalData?: string;
    isSelected?: boolean;
  }[];
  selectedValue?: any;
  placeholder?: string;
  onDismiss: () => void;
  onSelect: (selectedValue: any) => any;
  enableSearch: boolean;
  icon?: string | ReactElement;
  isDisabled?: boolean;
  setObject?: boolean;
  additionalLabel?: string;
};
export const DropDown = ({
  data,
  selectedValue,
  placeholder,
  onDismiss,
  onSelect,
  icon,
  enableSearch,
  isDisabled,
  setObject,
  additionalLabel,
}: DropDownProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleSelect = (e: any, event: any) => {
    onSelect(e);
  };
  useEffect(() => {}, [selectedValue]);
  const handleSearchChange = (e: any) => {
    setSearchTerm(e.target.value);
  };
  const onDropdownToggle = () => {
    setSearchTerm('');
  };
  const displaySelectedLabel = selectedValue
    ? data.find((d) => d.value === selectedValue)?.label
    : '';
  const filteredOptions = data.filter((d) =>
    d.label.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
  );
  return (
    <Dropdown className="custom" onToggle={onDropdownToggle}>
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className="drop-down-btn"
        disabled={isDisabled}
      >
        <div className={`btn-selected-text ${!displaySelectedLabel ? 'placeholder-ctr' : ''}`}>
          {displaySelectedLabel ? displaySelectedLabel : placeholder ? placeholder : 'Select'}
        </div>
        <img src={DownArrow} className="down-arrow" />
      </Dropdown.Toggle>
      <Dropdown.Menu className={`${enableSearch ? 'search' : ''}`}>
        {enableSearch && (
          <div
            className="dropdown-item search"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        )}
        <div className="menu-scroller">
          {filteredOptions?.map((item, index) => {
            return (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  onSelect(setObject ? item : item.value);
                }}
                eventKey={item.value}
              >
                <div className="menu-item-minutes">
                  <div>
                    <div className="label">{item.label}</div>
                    {item.additionalData && (
                      <div className="additional">
                        {item.additionalData ? item.additionalData : ''}
                      </div>
                    )}
                  </div>
                  {selectedValue && selectedValue == item.value ? (
                    <img src={ListCheck} className="ListCheck" />
                  ) : null}
                </div>
              </Dropdown.Item>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
